import { Article } from '~/models/Article';

export function selectArticle(props) {
  const article = new Article(props.article);
  const relatedArticles = (props.relatedArticles || [])
    .map((a) => new Article(a));

  return {
    ...getPrevAndNext(relatedArticles, article.uuid),
    article,
    relatedArticles,
  };
}

function getPrevAndNext(articles, currentArticleUuid) {
  const position = articles.findIndex(article => article.uuid === currentArticleUuid);
  const nextArticleSlug = articles[position + 1]?.fullSlug;
  const prevArticleSlug = articles[position - 1]?.fullSlug;

  return { nextArticleSlug, prevArticleSlug };
}
